module.exports = __webpack_public_path__ + "media/images/front/common/userIcon_minna_premium-03a06db3bdf75123df92ac8e91ea8853.png";